<!-- 处理数据，作为最顶层 menu 载体 -->
<template>
  <!-- 一级menu菜单 -->
  <el-menu
    :collapse="!$store.getters.sidebarOpened"
    :default-active="activeMenu"
    background-color="#fff"
    text-color="#525C6A"
    active-text-color="#fff"
    :unique-opened="true"
    router
  >
    <sidebar-item
      v-for="item in routes"
      :key="item.path"
      :route="item"
    ></sidebar-item>
  </el-menu>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { filterRouters, generateMenus } from '@/utils/router'
import SidebarItem from './SidebarItem.vue'

const router = useRouter()
const routes = computed(() => {
  const fRoutes = filterRouters(router.getRoutes())
  return generateMenus(fRoutes)
})
// 默认激活 根据当前的url进行判断
const route = useRoute()
const activeMenu = computed(() => {
  const { path } = route
  return path
})
</script>

<style lang='scss' scoped>
::v-deep .el-menu-item.is-active {
  background-color: #4D9262 !important;
}
</style>
